<template>
  <svg
    version="1.1"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    class="proposed-shipment-icon"
    role="document"
  >
    <title>{{ title }}</title>

    <circle cx="50" cy="50" r="48" :fill="proposedShipment.color" />
    <text x="50" y="50">
      {{ proposedShipment.identifier }}
    </text>
  </svg>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { ProposedShipment } from '@/model/routeBuilder';
import { RoutePlanProposedShipment } from '@/model/routeBuilder/phase2';

const props = defineProps({
  proposedShipment: {
    type: Object as PropType<ProposedShipment | RoutePlanProposedShipment>,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});
const { proposedShipment, title } = toRefs(props);
</script>

<style>
:root {
  --proposed-shipment-icon-width: 20px;
  /* font-size with SVG `text` behaves weird so this seems way too large */
  --proposed-shipment-icon-text-font-size: 48px;
  --proposed-shipment-icon-text-fill: white;
}

.proposed-shipment-icon {
  width: var(--proposed-shipment-icon-width);

  text {
    font-size: var(--proposed-shipment-icon-text-font-size);
    font-weight: bold;
    dominant-baseline: central;
    text-anchor: middle;
    fill: var(--proposed-shipment-icon-text-fill);
  }
}
</style>
